//DOWNLOAD_FILE
export const setIsFileDownloaded = (isDownloaded) => ({
    type : 'SET_DOWNLOAD_FILE',
    isDownloaded
});



// WEBPACK FOOTER //
// ./src/Actions/download.js